var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRoute = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 48 48",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24Z",
  fill: "#231F20"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.2 13.2h21.6v21.6H13.2z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m28.05 26.025 4.05-4.05-4.05-4.05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9 30.075a8.1 8.1 0 0 1 8.1-8.1h8.1",
  stroke: "#FFF",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));
export default SvgRoute;